import * as yup from 'yup'

export default yup.object().shape({
  name: yup
    .string()
    .required('Campo obrigatório')
    .matches(
      /^[a-zA-ZàáâäãåąčćęèéêëėįìíîïłńòóôöõøùúûüųūÿýżźñçčšžÀÁÂÄÃÅĄĆČĖĘÈÉÊËÌÍÎÏĮŁŃÒÓÔÖÕØÙÚÛÜŲŪŸÝŻŹÑßÇŒÆČŠŽ∂ð ,.'-]+$/u,
      'Nome inválido'
    ),
  email: yup
    .string()
    .email('Campo precisa ser um email')
    .required('Campo obrigatório'),
})
